"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
const SuccessPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(5.000000, 5.000000)"
}, _react.default.createElement("path", {
  d: "M11,2 C6.121,2 2,6.122 2,11 C2,15.877 6.121,19.998 11,19.998 C15.879,19.998 20,15.877 20,11 C20,6.122 15.879,2 11,2 M11,0 C16.963,0 22,5.038 22,11 C22,16.961 16.963,21.998 11,21.998 C5.037,21.998 0,16.961 0,11 C0,5.038 5.037,0 11,0 Z M15.618,6.7116 C15.183,6.3696 14.555,6.4466 14.214,6.8796 L14.214,6.8796 L9.337,13.0866 L7.625,11.7166 C7.192,11.3726 6.565,11.4426 6.219,11.8726 C5.874,12.3046 5.944,12.9336 6.375,13.2786 L6.375,13.2786 L8.875,15.2786 C9.054,15.4206 9.274,15.4976 9.5,15.4976 C9.538,15.4976 9.576,15.4956 9.615,15.4906 C9.88,15.4606 10.121,15.3256 10.286,15.1156 L10.286,15.1156 L15.786,8.1156 C16.128,7.6816 16.052,7.0526 15.618,6.7116 Z"
}))));
const SuccessMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  fill: "currentColor",
  d: "M12 0a12 12 0 1012 12A12.035 12.035 0 0012 0zm-2 17.414L4.586 12 6 10.586l4 4 8-8L19.414 8z"
}));
const AbstractSuccess = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(SuccessMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(SuccessPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractSuccess);